import { Component, EventEmitter, Output, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

import { Sidebar } from '../../../../core/services/sidebar';
import { Modal } from '../../../../core/services/modal';
import { Button } from "../../../../shared/ui/button/button";
import { IndividualOwners } from "./individual-owners/individual-owners";
import { CorporateOwners } from "./corporate-owners/corporate-owners";
import { ExecutiveManagement } from "./executive-management/executive-management";
import { AuthorizedSignatory } from "./authorized-signatory/authorized-signatory";
import { KEY_PERSONNEL_DETAILS_FORM_KEYS } from '../../../../shared/utils/constants';
import { KeyPersonnelFormKey, ModalOptions } from '../../../../shared/utils/types';
import { BaseModal } from '../../../../shared/components/modals/base-modal/base-modal';
import { StatusScreenComponent } from "../../../../shared/components/status-screen-component/status-screen-component";
@Component({
  selector: 'app-step3-key-personnel-details',
  imports: [TranslatePipe, CommonModule, Button, IndividualOwners, CorporateOwners, ExecutiveManagement, AuthorizedSignatory, StatusScreenComponent],
  templateUrl: './step3-key-personnel-details.html',
  styleUrl: './step3-key-personnel-details.css'
})
export class Step3KeyPersonnelDetails {
  @Input() data: any;
  @Input() onboardingStep!: number;
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();

  currentActiveForm: KeyPersonnelFormKey | null = null;
  showStatusScreen: boolean = false;
  formKeys = KEY_PERSONNEL_DETAILS_FORM_KEYS;

  formData: Record<string, any> = {
    [this.formKeys.INDIVIDUAL_OWNERS]: null,
    [this.formKeys.CORPORATE_OWNERS]: null,
    [this.formKeys.EXECUTIVE_MANAGEMENT]: null,
    [this.formKeys.AUTHORIZED_SIGNATORY]: null,
  };

  formsDetails = [
    { label: 'KEY_PERSONNEL_DETAILS.INDIVIDUAL_OWNERS', iconPath: 'assets/icons/user-blue.svg', key: this.formKeys.INDIVIDUAL_OWNERS },
    { label: 'KEY_PERSONNEL_DETAILS.CORPORATE_OWNERS', iconPath: 'assets/icons/building.svg', key: this.formKeys.CORPORATE_OWNERS },
    { label: 'KEY_PERSONNEL_DETAILS.EXECUTIVE_MANAGEMENT', iconPath: 'assets/icons/management.svg', key: this.formKeys.EXECUTIVE_MANAGEMENT },
    { label: 'KEY_PERSONNEL_DETAILS.AUTHORIZED_SIGNATORY', iconPath: 'assets/icons/double-check.svg', key: this.formKeys.AUTHORIZED_SIGNATORY }
  ];

  constructor(private sidebarService: Sidebar, private modalService: Modal, private router: Router) { }

  ngOnInit(): void {
    this.sidebarService.setLinks([
      { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
      { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
    ]);
  }

  /** Opens a form section */
  handleFormClick(key: any) {
    this.currentActiveForm = key;
  }

  /** Called when a form is submitted */
  handleFormSubmit(key: string, data: any) {
    this.formData[key] = data;
    // console.log(this.formData[key]);
    this.currentActiveForm = null;
  }

  isIndividualOwnersCompleted(): boolean {
    return !!this.formData[this.formKeys.INDIVIDUAL_OWNERS];
  }

  goBackStep() {
    if (this.currentActiveForm === null) {
      this.prev.emit();
    } else {
      this.currentActiveForm = null;

      // re-evaluate sidebar buttons or UI state
      this.sidebarService.setLinks([
        { label: 'SIDEBAR.PREVIOUS_SCREEN', action: () => this.goBackStep(), iconPath: 'assets/icons/arrow-blue.svg', variant: 'outlined' },
        { label: 'SIDEBAR.SAVE_EXIT', route: '/', iconPath: 'assets/icons/cancel-blue.svg', variant: 'plain' }
      ]);
    }
  }

  handleNextStep() {
    this.confirmModal();
  }

  confirmModal() {
    const baseModalOptions: ModalOptions = {
      backdropClosable: false,
      showCancelButton: true,
      showConfirmButton: true,
      textConfrimButton: 'KEY_PERSONNEL_DETAILS.SUBMIT_NOW',
      textCancelButton: 'KEY_PERSONNEL_DETAILS.GO_BACK',
      size: 'lg',
      headerIconPath: 'assets/icons/info-yellow.svg',
      title: 'KEY_PERSONNEL_DETAILS.CONFIRM_MODAL_TITLE',
      message: 'KEY_PERSONNEL_DETAILS.CONFIRM_MODAL_DESCRIPTION',
      onConfirm: () => {
        this.showStatusScreen = true;
        this.modalService.close();
      },
      onCancel: () => {
        this.modalService.close();
      }
    };

    this.modalService.open(BaseModal, baseModalOptions);
  }


  closeCurrentForm() {
    this.currentActiveForm = null;
  }

  handleLogout() {
    this.router.navigate(['/']);
  }
}
